module.exports = __webpack_public_path__ + "static/media/right-arrow.e497e6ef.svg";